module.exports = __webpack_public_path__ + "static/media/SaveAway401kSensible.38ee68bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/About/Assets/SaveAway401kSensible.png
// module id = 307
// module chunks = 0